import { Box, Paper, Stack, Typography } from '@mui/material';
import tokens from '../shared/theme/tokens';

/**
 * Standard surface card. Replaces the hand-rolled `Box` +
 * copy-pasted shadow string pattern used across the lease panels.
 *
 * Props:
 * - title: optional header text (h4, with bottom divider)
 * - action: optional node rendered on the right of the header row
 * - padding: body padding (default 2.25)
 * - sx: merged onto the Paper root
 */
export default function Panel({ title, action, padding = 2.25, sx, children }) {
  return (
    <Paper
      elevation={1}
      sx={{
        border: `1px solid ${tokens.colors.border}`,
        borderRadius: `${tokens.radius.md}px`,
        overflow: 'hidden',
        ...sx,
      }}
    >
      {(title || action) && (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          gap={1.5}
          sx={{ px: 2.25, py: 1.75, borderBottom: `1px solid ${tokens.colors.border}` }}
        >
          {title && (
            <Typography variant="h4" sx={{ fontSize: 14 }}>
              {title}
            </Typography>
          )}
          {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
        </Stack>
      )}
      <Box sx={{ p: padding }}>{children}</Box>
    </Paper>
  );
}
